export enum AppPreferenceKeys {
  MONITORING_SYSTEM_LIST = 'monitoringSystemLists',
  MONITORING_SHARED_LISTS = 'monitoringSharedLists',
  MONITORING_LIST_TEMPLATES = 'monitoringListTemplates',
}
